import { appLoading } from "../actions/alertAction";
import { ERROR, SUCCESS } from "../constants/types/alertType";
import {
  ADDRESS_LIST_RETERIEVED,
  CARD_LIST_RETRIEVED,
  CLINIC_INFO_RECEIVED,
  FULLSCRIPT_TREATMENTPLAN_RETRIEVED,
  PATIENT_PROFILE_RECEIVED,
  PRACTITIONER_PROFILE_RECEIVED,
  USER_INFO_RECEIVED,
  PRACTITIONER_COMMISSION_RETERIEVED,
  SHIPPING_PRICE_RETRIEVED,
  QR_CODE_URL_RECEIVED,
} from "../constants/types/profileType";
import axios from "../utils/axios";
import { getUserDetail, setUsetDetailToLocalStorage } from "../utils/helper";

export const getPatientProfile = (patientId, callback) => (dispatch) => {
  axios.get(`profile?action=getPatientProfile&ppc_id=${patientId}`).then(
    (resp) => {
      if (resp.data) {
        dispatch({
          type: PATIENT_PROFILE_RECEIVED,
          payload: resp.data ? resp.data[0] : null,
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get patient profile",
      });
      callback && callback();
    }
  );
};

export const getPractitionerProfile = (practitionerId) => (dispatch) => {
  axios
    .get(
      `profile?action=getPractitionerProfilePublic&practitioner_id=${practitionerId}`
    )
    .then(
      (resp) => {
        if (resp.data) {
          dispatch({
            type: PRACTITIONER_PROFILE_RECEIVED,
            payload: resp.data ? resp.data[0] : null,
          });
        }
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to get patient profile",
        });
      }
    );
};

export const getFullscriptStatus = (callback) => (dispatch) => {
  axios.get("profile?action=getFullscriptStatus").then(
    (resp) => {
      if (resp.data) {
        callback && callback(resp?.data?.isConnected);
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get patient profile",
      });
    }
  );
};

export const getClinicInformation = () => (dispatch) => {
  axios.get("profile?action=getClinicsInfo").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: CLINIC_INFO_RECEIVED,
          payload: resp.data.clinicInfo,
        });
      } else {
        dispatch({
          type: CLINIC_INFO_RECEIVED,
          payload: null,
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get Clinic Information",
      });
    }
  );
};
export const getPersonalInformation = (callback) => (dispatch) => {
  axios.get("profile?action=getContactInfo").then(
    (resp) => {
      if (resp.data) {
        dispatch({
          type: USER_INFO_RECEIVED,
          payload: resp.data ? resp.data : null,
        });
        callback && callback(resp.data);
      }
    },
    (err) => {
      callback && callback();
      dispatch({
        type: ERROR,
        payload: "Failed to get personal information",
      });
    }
  );
};

export const analyticsPostAction = (data, callback) => (dispatch) => {
  axios.post(`analyticsAdmin`, data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback(true);
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        callback && callback(false);
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      callback && callback(false);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getBillingShippingAddress = (callback) => (dispatch) => {
  axios.get("profile?action=getBillingShipping").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: ADDRESS_LIST_RETERIEVED,
          payload: resp.data.addressList,
        });
      } else {
        dispatch({
          type: ADDRESS_LIST_RETERIEVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }

      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get address list",
      });
    }
  );
};

export const getPractitionerCommission = (callback) => (dispatch) => {
  axios.get("profile?action=getPractitionerCommission").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: PRACTITIONER_COMMISSION_RETERIEVED,
          payload: resp.data.commission,
        });
      } else {
        dispatch({
          type: PRACTITIONER_COMMISSION_RETERIEVED,
          payload: null,
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }

      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get commission",
      });
    }
  );
};

export const getCreditCards = (callback) => (dispatch) => {
  axios.get("profile?action=getCreditCards").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: CARD_LIST_RETRIEVED,
          payload: resp.data.cardList,
        });
      } else {
        dispatch({
          type: CARD_LIST_RETRIEVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get card list",
      });
    }
  );
};

export const getShippingPrice = (id, callback) => (dispatch) => {
  axios.get(`profile?action=getShippingPrice&address_id=${id}`).then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: SHIPPING_PRICE_RETRIEVED,
          payload: resp.data.shippingRates,
        });
      } else {
        dispatch({
          type: SHIPPING_PRICE_RETRIEVED,
          payload: null,
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get shipping price list",
      });
    }
  );
};

export const profilePostAction = (data, callback) => (dispatch) => {
  dispatch(appLoading(true));
  axios.post("profile", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        if (resp.data?.secret_token) {
          callback && callback(resp.data?.secret_token);
          dispatch(appLoading(false));
          return;
        }
        if ((data.params.action = "verifyLoginCode")) {
          dispatch({
            type: SUCCESS,
            payload: resp.data.message,
          });
          callback(true);
          dispatch(appLoading(false));
          return;
        }
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
        dispatch(appLoading(false));
      } else {
        callback && callback();
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
        dispatch(appLoading(false));
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      dispatch(appLoading(false));
    }
  );
};

export const getFullscriptTreamtmentplanList =
  (data, callback) => (dispatch) => {
    axios.post("profile", data).then(
      (resp) => {
        if (resp.data.result === "success") {
          if (resp.data) {
            dispatch({
              type: FULLSCRIPT_TREATMENTPLAN_RETRIEVED,
              payload: resp.data.treatmentplanList,
            });
          }
          callback && callback();
        } else {
          callback && callback();
          dispatch({
            type: ERROR,
            payload: resp.data.error,
          });
        }
      },
      (err) => {
        console.log(err);
        callback && callback();
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
      }
    );
  };

export const SubscriptionPostAction = (data, callback) => (dispatch) => {
  axios.post("subscription", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
        callback && callback();
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const updateClinicLogo = (data, callback) => (dispatch) => {
  axios({
    method: "post",
    url: "clinicLogo",
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
  }).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const LogoPostAction = (data, callback) => (dispatch) => {
  axios.post("clinicLogo", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const LogoGetAction = (data, callback) => (dispatch) => {
  axios.get("clinicLogo?clinic_id=53").then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const uploadProfile = (file, callback) => (dispatch) => {
  let formData = new FormData();
  formData.append("token", getUserDetail()?.token);
  formData.append("profile_picture", file);
  axios({
    method: "post",
    url: "profilePicture",
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  }).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        var user = getUserDetail();
        user.hasProfilePicture = 1;
        user.user = {
          first_name: user.firstName,
          last_name: user.lastName,
        };
        setUsetDetailToLocalStorage(user);
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
        window.location.reload();
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getQrUrlCode = (token, callback) => (dispatch) => {
  axios.get(`profile?action=getQrCode&token=${token}`).then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: QR_CODE_URL_RECEIVED,
          payload: resp.data.qrDetails,
        });
        callback && callback();
      } else {
        dispatch({
          type: QR_CODE_URL_RECEIVED,
          payload: null,
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
        callback && callback();
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get qr info",
      });
      callback && callback();
    }
  );
};

export const becomePractitioner = (data, callback) => (dispatch) => {
  axios({
    method: "post",
    url: "profile",
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
  }).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback(true);
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        callback && callback(false);
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      callback && callback(false);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};
